import { useClientState } from './state';
import { useCart } from './cart';

export const useStoreEvents = defineStore('repo.client.events', () => {
    const {
        hook
    }: any = useNuxtApp();

    const {
        settings
    } = useClientState();

    const {
        cartManager
    } = useCart();

    hook('i18n:localeSwitched', ({ oldLocale, newLocale }: any) => {
        settings.language = newLocale;

        cartManager.setTimestamp(); // Will trigger cart update (check).
    });
});